import { render, staticRenderFns } from "./tarihcomp.vue?vue&type=template&id=f2969082&"
import script from "./tarihcomp.vue?vue&type=script&lang=js&"
export * from "./tarihcomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports